import React from "react";
import { useForm } from "react-hook-form";
import { Button } from "@ui/Button";
import { Input } from "@ui/Input";
import { MessageSeverity } from "@shared/types/Severity";
import { toast } from "@utilities/toast";

export type LogisticsPartnerFormData = {
  name: string;
};

type LogisticsPartnerFormProps = {
  onSubmit: (data: LogisticsPartnerFormData) => void | Promise<void>;
  defaultValues?: Partial<LogisticsPartnerFormData>;
  submitText?: string;
};

export function LogisticsPartnerForm({
  onSubmit,
  defaultValues = {
    name: undefined,
  },
  submitText = "Submit",
}: LogisticsPartnerFormProps) {
  const {
    register,
    handleSubmit,
    reset,
    formState: { isSubmitting, errors },
  } = useForm<LogisticsPartnerFormData>({
    defaultValues,
  });
  const wrappedOnSubmit = async (data: LogisticsPartnerFormData) => {
    try {
      await onSubmit(data);
      reset();
    } catch (error) {
      if (error.message) {
        toast.current?.show({
          severity: MessageSeverity.error,
          summary: "",
          detail: error.message,
        });
      }
    }
  };

  return (
    <form onSubmit={handleSubmit(wrappedOnSubmit)}>
      <div className="grid grid-cols-1 gap-4">
        <div>
          <label
            htmlFor="name"
            className="block text-sm font-medium text-gray-700"
          >
            Name
          </label>
          <div className="mt-1 mb-3">
            <Input
              type="text"
              {...register("name", {
                required: {
                  value: true,
                  message: "Name is required",
                },
              })}
              id="name"
              placeholder="Name"
              error={errors.name?.message}
            />
          </div>
        </div>
        <div>
          <Button size="lg" type="submit" disabled={isSubmitting}>
            {submitText}
          </Button>
        </div>
      </div>
    </form>
  );
}
